import { Modal, type ModalProps } from '@mantine/core';

const CLASSES = {
  header: 'flex-col-reverse! items-stretch! gap-2!',
  title: 'w-full!',
  close:
    'self-end! rounded-full! bg-[var(--mantine-color-red-6)]! text-white! hover:bg-[var(--mantine-color-red-7)]!',
  body: 'text-base',
};

const FILL_CLASSES = {
  ...CLASSES,
  content: 'flex! flex-col!',
  body: 'text-base flex min-h-0 grow flex-col',
};

export function PortalModal({
  fill,
  closeButtonProps,
  attributes,
  ...props
}: ModalProps & { fill?: boolean }) {
  return (
    <Modal
      centered
      classNames={fill ? FILL_CLASSES : CLASSES}
      closeButtonProps={{ 'aria-label': 'Close dialog', ...closeButtonProps }}
      attributes={{
        ...attributes,
        header: { role: 'presentation', ...attributes?.header },
      }}
      {...props}
    />
  );
}
